'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported from "./presto.-Two-Factor-Auth-View$-Imported.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$48(failed$3) {
  this.Ys = null;
  this.Ys = failed$3;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$48 as $c_Lpresto_TwoFactorAuthView$$anon$48 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$48.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$48;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$48() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$48 as $h_Lpresto_TwoFactorAuthView$$anon$48 };
$h_Lpresto_TwoFactorAuthView$$anon$48.prototype = $p;
$p.aev = (function(x) {
  return (this.Ys.aG(x.i7) || (!x.iD.k()));
});
$p.acs = (function(x, default$1) {
  if (this.Ys.aG(x.i7)) {
    var error$2 = this.Ys.bw(x.i7);
    return new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported.$c_Lpresto_TwoFactorAuthView$Imported(x.i7, x.tY, x.oy, x.iD, error$2);
  } else {
    return ((!x.iD.k()) ? x : default$1.w(x));
  }
});
$p.cb = (function(x) {
  return this.aev(x);
});
$p.bk = (function(x, default$1) {
  return this.acs(x, default$1);
});
var $d_Lpresto_TwoFactorAuthView$$anon$48 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$48, "presto.TwoFactorAuthView$$anon$48", ({
  ST: 1,
  a4: 1,
  t: 1,
  z: 1,
  a: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$48 as $d_Lpresto_TwoFactorAuthView$$anon$48 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$48.js.map
